export default {
  isPaused: false,
  currentRenderTargetIndex: 0,
  pingPongSteps: 40,
  pendingMaskInject: false,
};
